import {createSlice } from '@reduxjs/toolkit'

const AddStaffSlice = createSlice({
    name: "AddStaffSlice",
    initialState: {
        AddedStaff: {
            id: '',
            FIO: '',
            Post: '',
            idCity: 0,
            Shift: 0,
            Rate: 0,
            Prize: 0
        },
        EditStaff: false
    },
    reducers: {
       ChangeValueAddStaff(state, actions){
        switch(actions.payload.Type){
            case('FIO'):{
                state.AddedStaff.FIO = actions.payload.Value
                break;
            }
            case('Post'):{
                state.AddedStaff.Post = actions.payload.Value
                break;
            }
            case('idCity'):{
                state.AddedStaff.idCity = actions.payload.Value
                break;
            }
            case('Shift'):{
                state.AddedStaff.Shift = actions.payload.Value
                break;
            }
            case('Rate'):{
                state.AddedStaff.Rate = actions.payload.Value
                break;
            }
            case('Prize'):{
                state.AddedStaff.Prize = actions.payload.Value
                break;
            }
            default:{
                break;
            }
        }
       },
       CleanValueAddStaff(state){
        state.AddedStaff = {
            id: '',
            FIO: '',
            Post: '',
            idCity: 0,
            Shift: 0,
            Rate: 0,
            Prize: 0
        }
        state.EditStaff = false
       },
       addEditStaff(state, actions){
        state.EditStaff = true
        state.AddedStaff.FIO = actions.payload.FIO
        state.AddedStaff.id = actions.payload.id
        state.AddedStaff.Post = actions.payload.Post
        state.AddedStaff.idCity = actions.payload.idCity
       }
    }
})

export default AddStaffSlice.reducer
export const { addEditStaff, ChangeValueAddStaff, CleanValueAddStaff } = AddStaffSlice.actions